import Vue from 'vue'
import Router from 'vue-router'
import login from '@/login'
import resource from '@/resource/index'
import content from '@/resource/content'
import exam from '@/resource/exam'
import exercises from '@/resource/exercises'
import motif from '@/resource/motif'
import grade from '@/grade/index'
import pack from '@/pack/index'
import packList from '@/pack/list'
import glossary from '@/pack/glossary'
import read from '@/pack/read'
import readExam from '@/pack/read-exam'
import vip from '@/vip/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      meta:{
        title:'登录'
      }
    },
    {
      path: '/resource',
      name: 'resource',
      component: resource,
      meta:{
        title:'实词虚词管理'
      }
    },
    {
      path: '/grade',
      name: 'grade',
      component: grade,
      meta:{
        title:'年级学期管理'
      }
    },
    {
      path: '/packList',
      name: 'packList',
      component: packList,
      meta:{
        title:'资源包管理'
      }
    },
    {
      path: '/pack',
      name: 'pack',
      component: pack,
      meta:{
        title:'资源包付费管理'
      }
    },
    {
      path: '/vip',
      name: 'vip',
      component: vip,
      meta:{
        title:'会员管理'
      }
    },
    {
      path: '/content',
      name: 'content',
      component: content,
      meta:{
        title:'实词虚词词库'
      },
    },
    {
      path: '/exam',
      name: 'exam',
      component: exam,
      meta:{
        title:'古诗文词库'
      },
    },
    {
      path: '/glossary',
      name: 'glossary',
      component: glossary,
      meta:{
        title:'资源包词库设置'
      },
    },
    {
      path: '/exercises',
      name: 'exercises',
      component: exercises,
      meta:{
        title:'现代文阅读习题'
      },
    },
    {
      path: '/motif',
      name: 'motif',
      component: motif,
      meta:{
        title:'现代文阅读母题'
      },
    },
    {
      path: '/read',
      name: 'read',
      component: read,
      meta:{
        title:'现代文阅读--词库'
      },
    },
    {
      path: '/readExam',
      name: 'readExam',
      component: readExam,
      meta:{
        title:'现代文阅读--题库'
      },
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js